import React, { Component } from "react";
import {
  Segment,
  Grid,
  Table,
  Header,
  Divider,
  Icon,
} from "semantic-ui-react";
import { Link } from "react-router-dom";
import feathers from "../../feathers-client";
import swal from "sweetalert";

class ListaMaestros extends Component {
  state = {
    maestros: [],
    loading: true,
  }

  componentDidMount() {
    this.getMaestros()
  }

  getMaestros = () => {
    const clases = feathers.service("users");
    clases.find({
      query: {
        $limit: 1000
      }
    })
      .then(res => {
        this.setState({ maestros: res.data, loading: false })
      })
  }

  handleDelete = Id => {
    swal({
      title: "¿Seguro desea eliminar el maestro?",
      text:
        "Esta operación es irreversible",
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(async willDelete => {
      if (willDelete) {
        await feathers
          .service("users")
          .remove(Id)
          .then(res => {
            console.log(res);
            swal("Maestro eliminado correctamente", { icon: "success", timer: 1500 });
            this.getMaestros();
          })
          .catch(err => {
            console.log(err);
            swal("Ocurrió un error. Intente más tarde", { icon: "error" });
          });
      }
    });
  };

  render() {

    return (
      <Segment loading={this.state.loading}>
        <Grid>
          <Grid.Column width={12}>
            <Header as="h1">
              <Icon name="list" />
              <Header.Content>Listado de Maestros</Header.Content>
            </Header>
          </Grid.Column>
          <Grid.Column width={4}>
            <Link to="crear-maestro">
              <Icon name='plus' size="big" color="green" />
            </Link>
          </Grid.Column>
        </Grid>

        <Divider />
        <Grid style={{ padding: "0 20px" }}>
          <Grid.Row width={16}>
            <Table celled striped>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>#</Table.HeaderCell>
                  <Table.HeaderCell>Nombre</Table.HeaderCell>
                  <Table.HeaderCell>Usuario</Table.HeaderCell>
                  <Table.HeaderCell>Clase</Table.HeaderCell>
                  <Table.HeaderCell>Acciones</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {this.state.maestros.map((m, i) => (
                  <Table.Row key={i}>
                    <Table.Cell>{i + 1}</Table.Cell>
                    <Table.Cell>{m.full_name}</Table.Cell>
                    <Table.Cell>   {m.username}</Table.Cell>
                    <Table.Cell>{m.clase.name}</Table.Cell>
                    <Table.Cell>
                      <Link to="#" onClick={() => this.handleDelete(m.id)}>
                        <Icon name="trash" color="grey" /> Eliminar
                      </Link>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <Link to={`/editar-maestro/${m.id}`}>
                        <Icon name="pencil" color="grey" /> Editar
                      </Link>
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </Grid.Row>
        </Grid>
      </Segment>
    )
  }
}

export default ListaMaestros;